export interface SourceTags {
  SourceFile: string;
  SourceClass: string;
  SourceLayer: string;
  tags: string[];
}

const LAYER_ALIASES: Record<string, string> = {
  components: 'Components',
  utils: 'Utils',
  dashboard: 'Dashboard',
  'sign-in': 'SignIn',
  register: 'Register',
  upgrade: 'Upgrade',
  landing: 'Landing',
  policy: 'Policy',
  privacy: 'Privacy',
  terms: 'Terms',
  'shared-theme': 'SharedTheme',
  logging: 'Logging',
};

export function sourceTagsFromPath(relativePath: string): SourceTags {
  const normalized = relativePath.replace(/\\/g, '/');
  const fileName = normalized.split('/').pop() ?? relativePath;
  const parts = normalized.split('/');
  const folder = parts.length > 1 ? parts[0] : 'src';
  const nestedFolder = parts.length > 2 ? parts[1] : undefined;
  const sourceLayer =
    nestedFolder === 'components'
      ? 'Components'
      : LAYER_ALIASES[folder] ?? folder;

  const sourceClass = fileName.replace(/\.(tsx?|jsx?)$/, '');

  return {
    SourceFile: fileName,
    SourceClass: sourceClass,
    SourceLayer: sourceLayer,
    tags: [fileName, sourceClass, sourceLayer],
  };
}

export function sourceTagsFromStack(stack?: string, skipFrames = 2): SourceTags {
  if (!stack) {
    return sourceTagsFromPath('Unknown.ts');
  }

  const lines = stack.split('\n').slice(skipFrames);
  for (const line of lines) {
    const srcMatch = line.match(/[/\\]src[/\\]([^?)]+?\.(?:tsx?|jsx?))/);
    if (srcMatch) {
      return sourceTagsFromPath(srcMatch[1]);
    }
  }

  return sourceTagsFromPath('Unknown.ts');
}

export function sourceTagsFromComponentName(componentName: string): SourceTags {
  return {
    SourceFile: `${componentName}.tsx`,
    SourceClass: componentName,
    SourceLayer: 'Components',
    tags: [`${componentName}.tsx`, componentName, 'Components'],
  };
}
